//#region src/domain/i18n/time-zone.ts
var TimeZone = /* @__PURE__ */ function(TimeZone) {
	TimeZone["DO"] = "America/Santo_Domingo";
	TimeZone["GT"] = "America/Guatemala";
	TimeZone["HN"] = "America/Tegucigalpa";
	TimeZone["PE"] = "America/Lima";
	return TimeZone;
}({});
//#endregion
export { TimeZone };

//# sourceMappingURL=time-zone.js.map